module.exports = __webpack_public_path__ + "img/icon_--_send_later.61059912.png";